
import React from 'react';
import { Card, CardContent, Typography, Grid, IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const TipoCuentasCard = ({ row, onEdit, onDelete, permissions }) => {
    const { id, detalle, tipo } = row;

    return (
        <Card sx={{ marginBottom: 2 }}>
            <CardContent>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="h6" component="div">
                            {detalle}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            ID: {id}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Tipo: {tipo}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} container direction="column" alignItems="flex-end">
                        {permissions.modificacion && (
                            <IconButton onClick={() => onEdit(row)} size="small" color="primary">
                                <EditIcon />
                            </IconButton>
                        )}
                        {permissions.baja && (
                            <IconButton onClick={() => onDelete(id)} size="small" color="error">
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
